<template>
  <div class="autocomplete city-search">
    <label for="deliver">Search For Your City</label>
    <input type="text" id="deliver" name="deliver" class="city-search-bar" v-model="localLoc">
    <ul class="autocomplete-items">
      <li class="prediction" v-for="(result, i) in searchedList" :key="i" @click="setValue(result)">
        {{result.area.name}}, {{ result.city.name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    found: {
      type: Function
    }
  },
  name: 'CitySearch',
  data: () => ({
    localLoc: ''
  }),
  watch: {},
  computed: {
    all_list_items () {
      const result = []
      this.arealist.map(city => {
        city.sub_areas.map(area => {
          result.push({
            city,
            area
          })
        })
      })
      return result
    },
    arealist () {
      return this.$store.state.api.arealist
    },
    searchedList () {
      if (this.localLoc !== '') {
        return this.all_list_items.filter(result => {
          if (result.area.name.toLowerCase().includes(this.localLoc.toLowerCase())) {
            return result
          }
        })
      } else {
        return []
      }
    }
  },
  methods: {
    setValue (value) {
      this.searchResults = []
      this.found(value)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.autocomplete{
  margin-top:0;
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: calc(100% - 0px);
  width:calc(100% - 50px);
  left: 25px!important;
  right: 0;
  background: white;
}
.autocomplete-items li {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #c3c3c3;
}
.autocomplete-items li:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;
}
.mobile {
  .traddress {
    .vx-col {
      padding: 0;
    }
  }
}
.city-search{
  width:100%;
  margin-bottom:20px;
  label {
    font-weight: 900;
    font-size:32px;
    text-align: center;
    width:100%;
    display: block;
    text-transform: uppercase;
    margin-bottom:20px;
  }
  .city-search-bar{
    width:100%;
    border:1px solid #ccc;
    border-radius: 25px;
    background-color:#ebebeb;
    padding:15px 15px;
    text-align: center;
  }
}
@media (max-width:768px){
  .city-search{
  label {
    font-size:18px;
  }
}
}
</style>
